<template>
  <v-container class="mt-12 my-5">
    <v-layout class="grey lighten-3 pa-2 mt-10">
      <v-flex xs12>
        <h1 class="text-center">
          {{
            chrome
              ? "Dashboard"
              : "Please use Google Chrome to best experience this application"
          }}
        </h1>
      </v-flex>
    </v-layout>

    <!-- Filter Buttons -->

    <FilterView
      :viewStatus="viewStatus"
      :getCountOfForms="getCountOfForms"
      :filterButton="filterButton"
      :locationSetter="locationSetter"
      :showFilters="showFilters"
      :sortAsc="sortAsc"
      :siteFilter="siteFilter"
      :sitesDropdown="sitesDropdown"
      :wasteFilter="wasteFilter"
      :wasteTypes="wasteTypes"
      :mobileSize="mobileSize"
      :userRole="userRole"
      :filterLocation="filterLocation"
      :retrieveForms="retrieveForms"
      :filterType="filterType"
      :dataLoading="dataLoading"
    />

    <!-- Filter Fields -->

    <v-row>
      <v-col :cols="mobileSize ? 12 : 6">
        <v-text-field
          class="mt-5"
          outline
          hide-details
          v-model="filterText"
          :label="getSearchLabel"
          @keyup="filterBar(copyForms)"
          :disabled="dataLoading"
          >{{ getSearchLabel }}</v-text-field
        >
      </v-col>
      <v-col :cols="mobileSize ? 12 : 6" class="mt-4">
        <v-autocomplete
          v-model="selectedDepartment"
          :items="departments"
          label="Search by Department Name"
          :disabled="dataLoading"
        >
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row> </v-row>

    <v-row v-if="dataLoading" class="d-flex justify-center">
      <v-col cols="12" class="reminders">
        <h3 class="reminder mt-6">Please wait as the data loads...</h3>
        <v-progress-circular
          indeterminate
          class="reminderSpinner"
        ></v-progress-circular>
      </v-col>
    </v-row>
    <v-row v-if="!dataLoading && forms.length && !mobileSize">
      <v-col class="d-flex justify-end">
        <v-btn @click="exportData" class="d-flex mt-1">Export</v-btn>
      </v-col>
    </v-row>

    <template v-if="!dataLoading">
      <v-layout>
        <v-flex xs12>
          <v-card
            class="pa-5 mt-5"
            tile
            outlined
            @click="formSelect(form.requestId)"
            v-for="form in getForms"
            :key="form.requestId"
          >
            <Card
              :form="form"
              :numberOfDaysOpen="numberOfDaysOpen"
              :mobileSize="mobileSize"
              :parseDate="parseDate"
            />
          </v-card>
        </v-flex>
      </v-layout>
    </template>
    <v-dialog content-class="Dashboard__Dialog" persistent v-model="dialog">
      <font-awesome-icon
        @click="exitForm"
        class="Dashboard__Dialog__Icon"
        icon="times-circle"
      ></font-awesome-icon>
      <Form
        :formHold="formHold"
        :closingNotes="closingNotes"
        :activityLog="activityLog"
        :activityDetails="activityDetails"
        :changeStatus="changeStatus"
        :print="print"
        :exitForm="exitForm"
        :approvedBy="approvedBy"
        :approvedByTitle="approvedByTitle"
        :user="user"
        :chargeable="chargeable"
        :parseDate="parseDate"
        @input="updateApprovedBy"
        @closing-notes="updateClosingNotes"
        @change-chargeable="updateChargeable"
        @add-pics="updatePics"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
import * as firebase from "@/firebase";
// import axios from "axios";
import { mapState, mapActions } from "vuex";
import firebaseLibrary from "firebase";

import FilterView from "./AdminDashboard/FilterView";
import Card from "./AdminDashboard/Card";
import Form from "./AdminDashboard/Form";

export default {
  components: { FilterView, Card, Form },
  data() {
    return {
      sitesDropdown: [
        { site: "Royal Free", hospital: true },
        { site: "Barnet", hospital: true },
        { site: "Chase Farm", hospital: true },
        { site: "Chalk Mill", hospital: false },
        { site: "Hadley Wood", hospital: false },
        { site: "Tottenham Hale", hospital: false },
        { site: "Graseby House", hospital: false },
        { site: "PEARS Building", hospital: false },
        { site: "Queen Mary's House", hospital: false },
        { site: "North Middlesex Hospital", hospital: false },
      ],
      wasteTypes: [
        "<Clear Filter>",
        "Furniture",
        "Waste Electricals",
        "Batteries",
        "Bulk Disposal",
        "Confidential",
        "Other",
      ],
      listMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      chrome: window.navigator.userAgent.indexOf("Chrome") > 1,
      dialog: false,
      sortAsc: false,
      forms: [],
      copyForms: [],
      activityLog: [],
      activityDetails: [],
      maintenancePics: [],
      viewStatus: "Site",
      prevStatus: "Site",
      pics: [],
      approvedBy: "",
      approvedByTitle: "",
      wasteFilter: "Waste Type",
      siteFilter: "Site",
      formHold: "",
      count: "",
      closingNotes: "",
      filterText: "",
      chargeable: false,
      mobileSize: window.innerWidth < 600,
      dataLoading: false,
      departments: [],
      selectedDepartment: "",
      filterType: "",
    };
  },
  methods: {
    ...mapActions(["setFilterLocation"]),
    async retrieveForms() {
      this.dataLoading = true;
      this.forms = [];
      this.copyForms = [];
      let collectionRef = "";

      if (this.userRole === "admin")
        collectionRef = firebase.db
          .collection("ukforms")
          .where(
            "sites",
            "==",
            this.filterLocation.length ? this.filterLocation : this.userLocation
          )
          .limit(50)
          .orderBy("requestId", "desc");
      else
        collectionRef = firebase.db
          .collection("ukforms")
          .where(
            "sites",
            "==",
            this.filterLocation.length ? this.filterLocation : this.userLocation
          )
          .limit(50)
          .orderBy("formType", "desc")
          .orderBy("requestId", "desc");

      const allForms = await collectionRef.get();
      const departments = [];
      this.sortAsc = !this.sortAsc;

      for (const doc of allForms.docs) {
        this.forms.push({
          ...doc.data(),
          id: doc.id,
        });

        if (doc.data().deptLocation.length)
          departments.push(doc.data().deptLocation.trim());
      }
      this.departments = ["<ALL>", "<NONE>", ...new Set(departments)];
      this.copyForms = this.forms;
      this.siteFilter = this.filterLocation.length
        ? this.filterLocation
        : this.userLocation;

      this.dataLoading = false;
    },
    async retrieveFormsByStatus(status) {
      this.dataLoading = true;
      this.forms = [];
      this.copyForms = [];
      let collectionRef = "";

      if (this.userRole === "admin")
        collectionRef = firebase.db
          .collection("ukforms")
          .where(
            "sites",
            "==",
            this.filterLocation.length ? this.filterLocation : this.userLocation
          )
          .where("status", "==", status)
          .limit(50)
          .orderBy("requestId", "desc");
      else
        collectionRef = firebase.db
          .collection("ukforms")
          .where("status", "==", status)
          .where(
            "sites",
            "==",
            this.filterLocation.length ? this.filterLocation : this.userLocation
          )
          .limit(50)
          .orderBy("formType", "desc")
          .orderBy("requestId", "desc");
      const allForms = await collectionRef.get();
      const departments = [];
      this.sortAsc = !this.sortAsc;

      for (const doc of allForms.docs) {
        this.forms.push({
          ...doc.data(),
          id: doc.id,
        });

        if (doc.data().deptLocation.length)
          departments.push(doc.data().deptLocation.trim());
      }
      this.departments = ["<ALL>", "<NONE>", ...new Set(departments)];
      this.copyForms = this.forms;
      this.siteFilter = this.filterLocation.length
        ? this.filterLocation
        : this.userLocation;

      this.dataLoading = false;
    },
    async retrieveAllForms() {
      this.dataLoading = true;
      this.forms = [];
      this.copyForms = [];
      const collectionRef = firebase.db
        .collection("ukforms")
        .orderBy("requestId", "desc");

      const allForms = await collectionRef.get();
      const departments = [];
      this.sortAsc = !this.sortAsc;

      for (const doc of allForms.docs) {
        this.forms.push({
          ...doc.data(),
          id: doc.id,
        });

        if (doc.data().deptLocation.length)
          departments.push(doc.data().deptLocation.trim());
      }
      this.departments = ["<ALL>", "<NONE>", ...new Set(departments)];
      this.copyForms = this.forms;
      this.siteFilter = this.filterLocation.length
        ? this.filterLocation
        : this.userLocation;

      this.dataLoading = false;
    },
    exitForm() {
      this.dialog = false;
      this.closingNotes = "";
      this.activityLog = [];
    },
    print() {
      let prtContent = document.getElementById("print").innerHTML;
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(`<!DOCTYPE html>
                <html>
                    <head>
                    <style>
                    .clear {
                        clear: both;
                    }
                    button.btnNoPrint {
                        visibility: hidden;
                    }
                    p.signature-line {
                        width: 50% !important
                    }
                    </style>
                    </head>
                    <body>
                        ${prtContent}
                    </body>
                </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    async storeImage(pic) {
      const picRef = await firebase.storage
        .ref()
        .child("images/" + pic.name)
        .put(pic);
      const url = await picRef.ref.getDownloadURL();
      return Promise.resolve(url);
    },
    async addPics() {
      return Promise.all(
        this.pics.map(async (pic) => {
          const url = await this.storeImage(pic);
          return url;
        })
      );
    },
    async changeStatus(id, status) {
      let found = this.forms.find((form) => form.id === id);
      const updateObj = {
        status,
        chargeable: this.chargeable,
      };
      let notes = "";
      if (this.closingNotes) notes = this.closingNotes;

      const activity =
        "[" +
        moment().format("YYYY-MM-DD hh:mm A") +
        "] " +
        this.user +
        " (" +
        status +
        ") ";

      let activityDetail = {
        activity,
        notes,
        picArray: [],
      };

      if (this.pics && this.pics.length) {
        let picArray = await this.addPics();
        updateObj.picArray = picArray;
        activityDetail.picArray = picArray;
      }

      if (found.activityLog) {
        found.activityLog.unshift(activity);
        updateObj.activityLog = found.activityLog;
        if (found.activityDetails) {
          found.activityDetails.unshift(activityDetail);
          updateObj.activityDetails = found.activityDetails;
        }
      } else {
        updateObj.activityLog = [];
        updateObj.activityLog.unshift(activity);
        updateObj.activityDetails = [];
        updateObj.activityDetails.unshift(activityDetail);
      }
      if (id) {
        if (
          status === "Closed" ||
          status === "Closed Not Completed" ||
          status === "On Hold"
        ) {
          updateObj.closedDate = firebaseLibrary.firestore.Timestamp.fromDate(
            moment().toDate()
          );
          updateObj.closingNotes = notes;
          updateObj.closedBy = this.user;
          updateObj.approvedBy = this.approvedBy;
          updateObj.approvedByTitle = this.approvedByTitle;
        } else if (status === "Open") {
          updateObj.reOpenDate = moment().format("YYYY-MM-DD");
          updateObj.closedDate = "";
        }
        firebase.db
          .collection("ukforms")
          .doc(id)
          .update(updateObj)
          .then(() => {
            this.dialog = false;
            this.closingNotes = "";
            this.approvedBy = "";
            this.approvedByTitle = "";
            this.showFilters("Open");
          })
          // .then(() => {
          //   if (status === "Closed") {
          //     axios
          //       .post(
          //         "https://us-central1-ukforms-764a8.cloudfunctions.net/sendMail2/sendClosedEmailToUser",
          //         found
          //       )
          //       .then((res) => console.log())
          //       .catch((err) => console.log("error", err));
          //   }
          // })
          .catch((error) => {
            // eslint-disable-next-line
            console.log("Error updating document: ", error);
          });
      } else {
        // eslint-disable-next-line
        console.log("empty");
      }
    },
    async showFilters(status) {
      this.viewStatus = status;
      this.activityLog = [];
      this.filterText = "";
      this.wasteFilter = "Waste Type";
      this.filterType = "";
      if (status === "All") await this.retrieveAllForms();
      else await this.retrieveFormsByStatus(status);
      if (status !== this.prevStatus) {
        this.sortAsc = true;
        this.prevStatus = status;
      }
    },
    formSelect(formRequestId) {
      let found = this.forms.find((form) => form.requestId === formRequestId);
      this.formHold = found;
      if (this.formHold.activityLog && this.formHold.activityLog.length)
        this.activityLog = this.formHold.activityLog;
      if (this.formHold.activityDetails && this.formHold.activityDetails.length)
        this.activityDetails = this.formHold.activityDetails;
      if (this.formHold.chargeable) this.chargeable = this.formHold.chargeable;
      if (this.formHold.closingNotes)
        this.closingNotes = this.formHold.closingNotes;
      this.dialog = true;
    },
    numberOfDaysOpen(requestId, status) {
      let dayOne = "";
      let dayTwo = "";
      let daysOpen = "";
      let closedMsg = "N/A";

      dayOne = moment(requestId.substring(0, 8));
      dayTwo = moment();
      daysOpen = dayTwo.diff(dayOne, "days");
      if (status === "Closed") return closedMsg;
      else return daysOpen;
    },
    numberByMonth() {
      let month = moment().format("MMM");
      return month;
    },
    filterBar(list) {
      this.forms = list.filter(
        (form) =>
          (form.deptLocation
            .toLowerCase()
            .includes(this.filterText.toLowerCase()) ||
            form.department
              .toLowerCase()
              .includes(this.filterText.toLowerCase()) ||
            (!this.mobileSize && form.requestId.includes(this.filterText))) &&
          (this.viewStatus !== "All" ? form.status === this.viewStatus : true)
      );
    },
    filterButton(filterText, type) {
      if (filterText === "<Clear Filter>") {
        this.wasteFilter = "Waste Type";
        this.forms = this.copyForms;
      } else if (filterText === "Confidential")
        this.forms = this.copyForms.filter(
          (form) => form.formType === filterText.toLowerCase()
        );
      else if (type === "Waste Type") {
        this.wasteFilter = filterText;
        this.forms = this.copyForms.filter((form) =>
          form.selected.includes(filterText)
        );
      } else if (filterText === "Chargeable") {
        if (this.filterType === filterText) {
          this.forms = this.copyForms;
          this.filterType = "";
        } else {
          this.forms = this.copyForms.filter(
            (form) => form[filterText.toLowerCase()]
          );
          this.filterType = filterText;
        }
      }
    },
    updateApprovedBy(input, type) {
      if (type === "title") this.approvedByTitle = input;
      else if (type === "person") this.approvedBy = input;
    },
    updateClosingNotes(input) {
      this.closingNotes = input;
    },
    updateChargeable() {
      this.chargeable = !this.chargeable;
    },
    updatePics(input) {
      this.pics = input;
    },
    exportData() {
      let dataStr = JSON.stringify(this.forms);
      let dataUri =
        "data:application/json;charset=utf-8," + encodeURIComponent(dataStr);

      let exportFileDefaultName = `${this.viewStatus
        .toLowerCase()
        .replaceAll(" ", "_")}_data.json`;

      let linkElement = document.createElement("a");
      linkElement.setAttribute("href", dataUri);
      linkElement.setAttribute("download", exportFileDefaultName);
      linkElement.click();
    },
    async locationSetter(site) {
      this.viewStatus = "Site";
      this.wasteFilter = "Waste Type";
      this.filterType = "";
      this.setFilterLocation(site);
      await this.retrieveForms();
      if (this.viewStatus !== this.prevStatus) {
        this.sortAsc = true;
        this.prevStatus = this.viewStatus;
      }
    },
    parseDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm A");
    },
  },
  watch: {
    selectedDepartment() {
      if (this.selectedDepartment) {
        if (this.selectedDepartment === "<ALL>") this.forms = this.copyForms;
        else if (this.selectedDepartment === "<NONE>")
          this.forms = this.copyForms.filter(
            (form) => !form.deptLocation.length && !form.department.length
          );
        else
          this.forms = this.copyForms.filter(
            (form) => form.deptLocation.trim() === this.selectedDepartment
          );
      }
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.firstName + " " + state.lastName,
    }),
    ...mapState({
      userLocation: (state) => state.location,
    }),
    ...mapState({
      filterLocation: (state) => state.filterLocation,
    }),
    ...mapState({
      userRole: (state) => state.role,
    }),
    getCountOfForms() {
      return this.forms.length;
    },
    getForms() {
      let arr = this.forms;
      if (!this.sortAsc)
        arr.sort(
          (a, b) => a.requestId.substring(0, 8) - b.requestId.substring(0, 8)
        );
      else
        arr.sort(
          (a, b) => b.requestId.substring(0, 8) - a.requestId.substring(0, 8)
        );
      return arr;
    },
    getSearchLabel() {
      return !this.mobileSize
        ? "Search By Request ID, Department Name, or Location Description"
        : "Search By Department Name";
    },
  },
  created() {
    this.retrieveForms();
  },
};
</script>

<style>
.arrow {
  color: rgb(123, 121, 121);
  margin-right: 5px;
}
.Dashboard__Dialog {
  max-width: 80%;
}
.Dashboard__Dialog__Icon {
  position: absolute;
  top: 3px;
  right: 20px;
  cursor: pointer;
  font-size: 1.5em;
}
.reminders {
  margin-top: 40px;
  padding-left: 35% !important;
}
.reminderSpinner {
  padding-left: 40%;
  margin-top: 30px;
}
.reminder {
  margin-left: 10%;
}
@media only screen and (min-width: 600px) {
  .Dashboard__Dialog {
    max-width: 60%;
  }
  .Dashboard__Dialog__Icon {
    top: 18px;
    right: 300px;
    font-size: 2.5em;
  }
}
</style>
